module.exports = __webpack_public_path__ + "static/media/08.cdb4f210.jpg";